import React, { useState, useEffect } from 'react';

const formatNumberWithCommas = (value) => {
  // Remove any existing commas and non-digit characters
  const number = value.replace(/[^\d]/g, '');
  // Add commas for thousands
  return number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const parseFormattedNumber = (value) => {
  // Remove commas and convert to number
  return parseInt(value.replace(/,/g, ''), 10);
};

export function AddOptionModal({ isOpen, onClose, onAdd }) {
  const [formData, setFormData] = useState({
    totalBudget: '',
    percentage: 5  // Default to 5%
  });

  const [minMaxValues, setMinMaxValues] = useState({
    minValue: 0,
    maxValue: 0
  });

  // Calculate min and max values whenever total budget or percentage changes
  useEffect(() => {
    if (formData.totalBudget) {
      const budget = parseFormattedNumber(formData.totalBudget);
      const variation = budget * (formData.percentage / 100);
      setMinMaxValues({
        minValue: Math.max(0, budget - variation),
        maxValue: budget + variation
      });
    }
  }, [formData.totalBudget, formData.percentage]);

  const handleNumberChange = (e) => {
    const formattedValue = formatNumberWithCommas(e.target.value);
    setFormData(prev => ({
      ...prev,
      totalBudget: formattedValue
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onAdd({
      totalBudget: parseFormattedNumber(formData.totalBudget),
      minValue: minMaxValues.minValue,
      maxValue: minMaxValues.maxValue
    });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Add New Option</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Total Budget ($)</label>
            <input
              type="text"
              value={formData.totalBudget}
              onChange={handleNumberChange}
              placeholder="Enter total budget"
              required
            />
          </div>

          <div className="form-group">
            <label>Budget Variation: {formData.percentage}%</label>
            <input
              type="range"
              min="1"
              max="20"
              value={formData.percentage}
              onChange={(e) => setFormData({...formData, percentage: parseInt(e.target.value)})}
              className="percentage-slider"
            />
          </div>

          <div className="budget-range-display">
            <div className="range-item">
              <span className="range-label">Minimum Budget:</span>
              <span className="range-value">${Math.round(minMaxValues.minValue).toLocaleString()}</span>
            </div>
            <div className="range-item">
              <span className="range-label">Maximum Budget:</span>
              <span className="range-value">${Math.round(minMaxValues.maxValue).toLocaleString()}</span>
            </div>
          </div>

          <div className="modal-actions">
            <button type="button" className="button-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="button-primary">
              Add Option
            </button>
          </div>
        </form>
      </div>
    </div>
  );
} 